/**
 * Onix Cart — best-seller suggestions + adapted cross-sell
 * ──────────────────────────────────────────────────────────────────────────────
 * #1 empty cart  → "Nos best-sellers": the 6 TOP best-sellers in real order from the
 *                  bestsellers pool (serialised as JSON in the cart drawer),
 *                  injected into the empty state via window.__onixRenderEmptyExtras
 *                  (cart-drawer.js calls it on every empty render).
 * #4 filled cart → "Complète ta commande": ADAPTED to the cart. Shopify product
 *                  recommendations (intent=related) for the most recently added
 *                  jersey, excluding what's in the cart; falls back to random
 *                  best-sellers when there are no recommendations.
 *
 * Every card uses the existing `[data-quick-add]="{handle}"` contract → the
 * global quick-add popup (size + flocage) handles the add with zero extra wiring.
 */
(function () {
  function root() {
    var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return r.slice(-1) === '/' ? r : r + '/';
  }
  function escAttr(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function fmtMoney(cents) {
    if (window.__onixFormatMoney) { try { return window.__onixFormatMoney(cents); } catch (e) {} }
    var a = (cents || 0) / 100;
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    if (cur === 'EUR') return a.toFixed(2).replace('.', ',') + '€';
    try { return new Intl.NumberFormat('en', { style: 'currency', currency: cur, currencyDisplay: 'narrowSymbol' }).format(a); }
    catch (e) { return a.toFixed(2) + ' ' + cur; }
  }

  /* Compact card from a product object {handle,url,title,featured_image,price,compare_at_price}.
     Used for BOTH the related-recommendations and the random best-sellers, so the
     two surfaces look identical. price/compare are in cents. */
  function recCard(p) {
    var article = document.createElement('article');
    /* Classe DÉDIÉE (onix-csug) — découplée de onix-promo-pcard (refait au
       modèle covred). Le design « suggestion panier » d'origine est défini
       dans assets/cart-drawer.css, toujours chargé avec le drawer. */
    article.className = 'onix-csug';
    var img = (typeof p.featured_image === 'string' && p.featured_image) || (p.images && p.images[0]) || '';
    if (img.indexOf('//') === 0) img = 'https:' + img;
    /* Only add the legacy _300x size hint when the URL isn't already sized. */
    if (img && !/(\?|&)width=|_\d+x\./.test(img)) img = img.replace(/(\.[a-zA-Z]+)(\?|$)/, '_300x$1$2');
    /* LE NOM À LA PLACE DU PRIX — 15/08, « j'ai bien aimé le concept de vignette
       photo produit que t'as fait dans la recherche, fais la même ici, ça prendra
       moins de place et moins de charge cognitive ».
       ⚠️ LA CARTE N'AVAIT AUCUN TITRE : six photos et six fois « 24,99 € », sur un
         catalogue où 558 produits sur 679 sont à ce prix. Le prix ne distinguait
         rien et occupait la seule ligne de texte ; le nom, lui, dit ce qu'on
         regarde.
       ⚠️ On ne découpe PAS le titre ici : `data-onix-title` + une classe qui finit
         par `__name`, et le snippet onix-card-title s'en charge — même découpage
         ÉQUIPE / MODÈLE que les cartes produit et que le tiroir de recherche, et
         même repli en sigle quand la ligne déborde. Un deuxième découpeur
         dériverait du premier à la première retouche.
       ⚠️ Le « + » reste, il sort juste du flux : il ouvre l'ajout rapide sans
         quitter le tiroir. Le retirer aurait allégé l'affichage en supprimant une
         fonction, ce qui n'est pas la même chose. */
    /* ⚠️ Le « + » est dans un ENVELOPPE avec la photo, pas frère de la carte :
       posé sur `.onix-csug` il se calait sur le bas de la CARTE, donc par-dessus
       la deuxième ligne du titre. Il doit se caler sur le bas de la PHOTO.
       Et il reste hors du `<a>` : un bouton dans un lien est du HTML invalide. */
    article.innerHTML =
      '<div class="onix-csug__media-wrap">' +
        '<a class="onix-csug__media" href="' + escAttr(p.url) + '">' +
          (img
            ? '<img class="onix-csug__image" src="' + escAttr(img) + '" loading="eager" alt="' + escAttr(p.title) + '">'
            : '<div class="onix-csug__image onix-csug__image--placeholder"></div>') +
        '</a>' +
        '<button type="button" class="onix-csug__plus" data-quick-add="' + escAttr(p.handle) + '" aria-label="' + escAttr(p.title) + '">' +
          '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg>' +
        '</button>' +
      '</div>';
    /* ⚠️ L3 — PLUS DE TITRE SOUS LA VIGNETTE. Sa consigne du 20/08 : « faut pas
         que les titres monopolisent de la place ». Mesuré sur la base F2+B2 :
         le bloc de titre pesait 40 à 53 px pour une image de 111, soit 32 % de
         la carte, et la grille tombe de 338 px à 231 — le plancher des images
         seules.
       ⚠️ LE TITRE N'EST PAS PERDU POUR AUTANT : il reste dans le `alt` de la
         photo et dans l'`aria-label` du bouton d'ajout. Un lecteur d'écran
         annonce donc toujours le maillot ; c'est l'affichage qui disparaît,
         pas l'information.
       ⚠️ Les règles CSS `.onix-csug__content` et `__name` restent dans la
         feuille : elles deviennent inertes, et les retirer demanderait de
         vérifier le snippet `onix-card-title`, qui vise toute classe finissant
         par `__name` — un autre chantier. */
    return article;
  }

  /* ── best-sellers pool ──
     A light instant set is serialised as JSON in the cart drawer (Liquid caps a
     collection loop at 50, so we keep that small); the FULL collection (up to 96)
     is fetched in the background and replaces the pool once ready. The empty cart
     keeps the real top order (6 best-sellers); the cross-sell fallback uses a
     per-session shuffle. */
  var bestsellersInstant = null; // from the Liquid JSON
  var bestsellersFull = null;    // from the collection AJAX (normalised)
  function instantPool() {
    if (bestsellersInstant) return bestsellersInstant;
    var el = document.getElementById('onix-cart-bestsellers');
    if (!el) return (bestsellersInstant = []);
    try { bestsellersInstant = JSON.parse(el.textContent) || []; } catch (e) { bestsellersInstant = []; }
    return bestsellersInstant;
  }
  function bestsellers() { return bestsellersFull || instantPool(); }

  function fetchFullBestsellers() {
    var el = document.getElementById('onix-cart-bestsellers');
    var handle = el && el.dataset.collection;
    if (!handle) return;
    fetch(root() + 'collections/' + encodeURIComponent(handle) + '/products.json?limit=96', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var prods = (d && d.products) || [];
        if (prods.length <= instantPool().length) return; // nothing gained
        bestsellersFull = prods.map(function (p) {
          var v = (p.variants && p.variants[0]) || {};
          return {
            handle: p.handle,
            url: root() + 'products/' + p.handle,
            title: p.title,
            featured_image: (p.images && p.images[0] && p.images[0].src) || '',
            price: Math.round(parseFloat(v.price || 0) * 100),
            compare_at_price: v.compare_at_price ? Math.round(parseFloat(v.compare_at_price) * 100) : 0
          };
        });
        sessionOrder(); // lock in a session order from the full 96-pool if not set yet
        /* The empty box / strip may have rendered from the small instant pool
           before this arrived. Re-render them (the drawer is hidden at this
           point, so no visible jank) so the picks come from the full pool and
           match the locked session order across pages. */
        var db = document.querySelector('[data-cart-drawer-body]');
        var eb = db && db.querySelector('.onix-cart-suggest__empty');
        if (eb) { eb.remove(); window.__onixRenderEmptyExtras(db); }
        schedule();
      })
      .catch(function () {});
  }

  /* A single random order per browsing SESSION (stored in sessionStorage so it
     stays the same across page navigations and cart re-opens; a fresh session
     gets a fresh shuffle). orderCache mirrors it in memory for this page. */
  var ORDER_KEY = 'onix_bs_order';
  var orderCache = null;
  function sessionOrder() {
    if (orderCache) return orderCache;
    try {
      var stored = sessionStorage.getItem(ORDER_KEY);
      if (stored) { var a = JSON.parse(stored); if (a && a.length) return (orderCache = a); }
    } catch (e) {}
    var handles = bestsellers().map(function (p) { return p.handle; });
    for (var i = handles.length - 1; i > 0; i--) { // Fisher-Yates, once per session
      var j = Math.floor(Math.random() * (i + 1));
      var t = handles[i]; handles[i] = handles[j]; handles[j] = t;
    }
    if (handles.length) {
      orderCache = handles;
      try { sessionStorage.setItem(ORDER_KEY, JSON.stringify(handles)); } catch (e) {}
    }
    return orderCache || handles;
  }
  function fillFromBestsellers(row, exclude, limit, ordered) {
    row.textContent = '';
    /* ordered=true → on garde l'ordre réel du pool (vraies meilleures ventes) ;
       sinon ordre mélangé par session (utilisé en fallback cross-sell). */
    var order = ordered ? bestsellers().map(function (p) { return p.handle; }) : sessionOrder();
    var byHandle = {};
    bestsellers().forEach(function (p) { byHandle[p.handle] = p; });
    var n = 0;
    for (var i = 0; i < order.length && n < limit; i++) {
      var p = byHandle[order[i]];
      if (!p || (exclude && exclude[p.handle])) continue;
      row.appendChild(recCard(p));
      n++;
    }
    return n;
  }

  /* ⛔ LE COMMENTAIRE D'ORIGINE ÉTAIT FAUX, ET ÇA A COÛTÉ UN PRIX FAUX — 04/09.
     Il affirmait que les étiquettes de la pop-up étaient « already
     currency-converted at boot via priceDisplay ». Mesuré sur le site public
     avec un cookie de pays : sur une page en CHF, ces étiquettes rendent
     « 29,99€ » — des EUROS. Et le repli du gabarit rendait « CHF 29.99 » là
     où la conversion donne « CHF 28.75 », parce que `{{ 2999 | money }}`
     FORMATE SANS CONVERTIR. Les DEUX chemins étaient faux ; personne n'avait
     mis l'affirmation à l'épreuve.
     ➜ La référence est maintenant `data-p*-eur`, en centimes d'EUROS, qu'on
       convertit par Shopify.currency.rate. Les étiquettes de la pop-up ne
       servent plus QUE si la boutique est en EUR — elles y sont justes, et
       elles portent d'éventuels réglages marchands qu'on veut respecter.
     Contrôle : node scripts/verifier-devise.js  (rougit sur la Suisse) */
  function readOfferPrices(tpl) {
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    var brut = window.Shopify && window.Shopify.currency && window.Shopify.currency.rate;
    var rate = parseFloat(brut);
    var d = (tpl && tpl.dataset) || {};

    /* ⛔ UN TAUX MANQUANT HORS EUR NE VAUT PAS 1 — trouvé par la revue, 05/09.
       La 1re version faisait `parseFloat(rate) || 1`. Si Shopify.currency.rate
       disparaissait sur une page en CHF, le taux retombait à 1 et le PRIX FAUX
       revenait intact — le défaut même qu'on venait de corriger, ressuscité par
       son propre repli. Un repli doit dégrader vers RIEN, jamais vers une
       valeur plausible. En EUR le taux vaut 1 par définition, donc l'absence
       y est inoffensive. */
    if (!isFinite(rate) || rate <= 0) rate = (cur === 'EUR') ? 1 : NaN;

    function converti(cents) {
      var n = parseInt(cents, 10);
      if (!isFinite(n) || n <= 0 || !isFinite(rate)) return '';
      return fmtMoney(Math.round(n * rate));
    }
    /* Hors EUR, un repli formaté par Liquid n'existe volontairement plus :
       mieux vaut pas de prix qu'un prix faux. */
    var p2 = converti(d.p2Eur) || (cur === 'EUR' ? (d.p2Fallback || '') : '');
    var p4 = converti(d.p4Eur) || (cur === 'EUR' ? (d.p4Fallback || '') : '');

    if (cur === 'EUR') {
      try {
        var t2 = document.querySelector('[data-offer-tier][data-tier-max="2"] [data-tier-price-label]');
        var t4 = document.querySelector('[data-offer-tier][data-tier-max="4"] [data-tier-price-label]');
        if (t2 && t2.textContent.trim()) p2 = t2.textContent.trim();
        if (t4 && t4.textContent.trim()) p4 = t4.textContent.trim();
      } catch (e) {}
    }
    return { p2: p2, p4: p4 };
  }

  /* ── empty cart: offer push + club shortcuts + best-sellers + reassurance.
     Cloned from the <template id="onix-empty-extras"> rendered in Liquid so
     all copy/links stay localized. Injected by the cart-drawer.js hook. ── */
  window.__onixRenderEmptyExtras = function (drawerBody) {
    if (!drawerBody) return;
    var emptyDiv = drawerBody.querySelector('.onix-cart-drawer__empty');
    if (!emptyDiv || emptyDiv.querySelector('.onix-empty-x')) return;
    var tpl = document.getElementById('onix-empty-extras');
    if (!tpl || !tpl.content) return;
    var strip = document.getElementById('onix-cart-suggest');
    if (strip) strip.hidden = true;

    var frag = tpl.content.cloneNode(true);

    /* ⚠️ DEUX MONTANTS, pas une phrase à trous. Le ticket porte les deux
       paliers ; les quantités (2 et 4) sont dans le gabarit, seuls les MONTANTS
       viennent d'ici. L'ancienne version composait une phrase depuis la locale
       (`2 maillots %p2% · 4 maillots %p4%`), ce qui interdisait de styler le
       nombre et le montant séparément. */
    var prixEls = {
      p2: frag.querySelector('[data-empty-offer-line]'),
      p4: frag.querySelector('[data-empty-offer-line4]'),
    };
    if (prixEls.p2 || prixEls.p4) {
      var prices = readOfferPrices(tpl);
      if (prixEls.p2 && prices.p2) prixEls.p2.textContent = prices.p2;
      if (prixEls.p4 && prices.p4) prixEls.p4.textContent = prices.p4;
    }

    var offerBtn = frag.querySelector('[data-empty-offer]');
    if (offerBtn) offerBtn.addEventListener('click', function () {
      var trigger = document.getElementById('onix-offer-trigger');
      if (trigger) trigger.click();
    });

    var bsWrap = frag.querySelector('[data-empty-bs]');
    if (bsWrap && bestsellers().length) {
      var bsTitle = frag.querySelector('[data-empty-bs-title]');
      if (bsTitle) bsTitle.textContent = tpl.dataset.bsTitle || (strip && strip.dataset.tBestsellers) || 'Nos best-sellers';
      var bsRow = frag.querySelector('[data-empty-bs-row]');
      if (bsRow) {
        fillFromBestsellers(bsRow, null, 6, true);
        /* Badge "Top des ventes" sur la 1re carte (preuve sociale, pas de stock). */
        var firstMedia = bsRow.querySelector('.onix-csug__media');
        if (firstMedia && tpl.dataset.topBadge) {
          var topBadge = document.createElement('span');
          topBadge.className = 'onix-csug__top';
          topBadge.textContent = tpl.dataset.topBadge;
          firstMedia.appendChild(topBadge);
        }
      }
      bsWrap.hidden = false;
    }

    emptyDiv.appendChild(frag);
  };

  /* ── #4 filled cart: recommendations adapted to the cart ── */
  var recCache = {};
  function getRecommendations(productId) {
    if (recCache[productId]) return Promise.resolve(recCache[productId]);
    return fetch(root() + 'recommendations/products.json?intent=related&limit=10&product_id=' + encodeURIComponent(productId), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) { recCache[productId] = (d && d.products) || []; return recCache[productId]; })
      .catch(function () { recCache[productId] = []; return []; });
  }

  /* ⛔ `is-open` VIT SUR LA RACINE, PAS SUR LE PANNEAU — mesuré le 05/09.
     `#OnixCartDrawer` est l'`<aside class="onix-cart-drawer__panel">`
     (snippets/cart-drawer.liquid l.66). La classe `is-open`, elle, est posée par
     `openDrawer()` sur `[data-cart-drawer-root]`, le `<div>` PARENT
     (assets/cart-drawer.js l.504). Deux tests écrits sur le panneau étaient donc
     TOUJOURS faux, en silence : celui de `renderStrip()` et celui d'`initial()`.
     Aucune erreur, aucune trace en console — la seule façon de le voir était
     d'ouvrir le tiroir et de lire les deux `className`.
     Relevé sur le thème d'aperçu, tiroir OUVERT :
       [data-cart-drawer-root] → « onix-cart-drawer is-open »
       #OnixCartDrawer         → « onix-cart-drawer__panel »   (jamais is-open)
     ⚠️ On garde `#OnixCartDrawer` pour le CONTENU (le corps du tiroir y est), et
     on prend la RACINE pour l'ÉTAT. Un seul point de lecture pour les deux. */
  function racineTiroir() { return document.querySelector('[data-cart-drawer-root]'); }
  function tiroirOuvert() {
    var r = racineTiroir();
    return !!(r && r.classList.contains('is-open'));
  }

  var renderGen = 0;
  function renderStrip() {
    var strip = document.getElementById('onix-cart-suggest');
    var panel = document.getElementById('OnixCartDrawer');
    if (!strip || !panel) return;
    /* Only do network/render work when the drawer is actually OPEN. Otherwise
       every background cart:refresh (add-to-cart from a product page, stepper
       ticks, discount-bar polling) would fire a /cart.js + /recommendations
       fetch with nothing visible — the main source of cart-open jank. */
    if (!tiroirOuvert()) return;
    var bodyEl = panel.querySelector('[data-cart-drawer-body]');
    if (bodyEl && bodyEl.querySelector('.onix-cart-drawer__empty')) { strip.hidden = true; return; } // empty state → handled by the hook, no fetch needed
    var row = strip.querySelector('.onix-cart-suggest__row');
    var title = strip.querySelector('.onix-cart-suggest__title');
    var gen = ++renderGen;
    fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (gen !== renderGen) return;
        var items = (cart.items || []).filter(function (i) { return !(i.properties && i.properties._offer_bundle === 'true'); });
        if (!items.length) { strip.hidden = true; return; } // empty handled by the hook
        var inCart = {};
        items.forEach(function (i) { if (i.handle) inCart[i.handle] = true; });
        var base = items[items.length - 1]; // most recently added product
        return getRecommendations(base.product_id).then(function (recs) {
          if (gen !== renderGen) return;
          var fresh = (recs || []).filter(function (p) { return p.handle && !inCart[p.handle]; });
          row.innerHTML = '';
          var shown = 0;
          if (fresh.length) {
            fresh.slice(0, 3).forEach(function (p) { row.appendChild(recCard(p)); shown++; });
          } else {
            shown = fillFromBestsellers(row, inCart, 3); // fallback: random best-sellers
          }
          if (title) title.textContent = strip.dataset.tComplete || 'Complète ta commande';
          strip.hidden = shown === 0;
        });
      })
      .catch(function () { /* leave the strip as-is on a network error */ });
  }

  /* setTimeout (not rAF) so it still fires when the cart lives in a backgrounded tab. */
  var timer = null;
  function schedule() { clearTimeout(timer); timer = setTimeout(renderStrip, 80); }

  /* ── LE TICKET DE L'OFFRE DÉCOUVERTE, À L'OUVERTURE DU TIROIR ─────────────
     ⛔ IL NE S'AFFICHAIT PAS DU TOUT SUR UN PANIER VIDE — mesuré le 05/09 sur le
       thème d'aperçu. Le commentaire d'origine affirmait : « the hook fires again
       when cart-drawer.js re-renders the empty state on open ». C'est FAUX.
       `openDrawer()` (assets/cart-drawer.js l.497) n'appelle AUCUN rendu ; les deux
       seuls appels à `__onixRenderEmptyExtras` sont dans `render(cart)` — après un
       aller-retour /cart.js, donc après une MODIFICATION du panier — et dans
       `optimisticEmptyIfLast()`, quand on retire le dernier article.
       ➜ Un visiteur qui arrive avec un panier vide et ouvre le tiroir voyait le
       `<div class="onix-cart-drawer__empty"></div>` rendu par Liquid, VIDE : pas
       de ticket « 2 pour 29,99€ / 4 pour 44,99€ », pas de best-sellers, rien.
       Le même tiroir montrait bien le ticket après avoir vidé le panier à la main.
       DEUX affichages pour un seul panier vide, dont un qui ne montre pas l'offre.
       Relevé, tiroir ouvert sur une arrivée directe : corps du tiroir = 71 caractères,
       `.onix-empty-x` absent ; forcé à la main, le ticket sort à 47 px de haut.
     ⚠️ ON N'INJECTE TOUJOURS PAS AU CHARGEMENT — l'intention d'origine était bonne :
       décoder six images de best-sellers hors écran à chaque page se paie. On
       injecte à l'OUVERTURE, c'est-à-dire au moment où ça se voit.
     ⚠️ L'OBSERVATEUR REGARDE LA RACINE, pas le panneau — voir `racineTiroir()`
       plus haut : c'est la racine qui reçoit `is-open`.
     ⚠️ `__onixRenderEmptyExtras` SE GARDE LUI-MÊME (il sort si `.onix-empty-x` est
       déjà là), donc rouvrir le tiroir dix fois ne le construit qu'une fois. */
  function auTiroirOuvert() {
    if (!tiroirOuvert()) return;
    var racine = racineTiroir();
    var drawerBody = racine && racine.querySelector('[data-cart-drawer-body]');
    if (drawerBody && drawerBody.querySelector('.onix-cart-drawer__empty')
        && window.__onixRenderEmptyExtras) {
      window.__onixRenderEmptyExtras(drawerBody);
    }
    schedule();   // panier rempli : la rangée « Complète ta commande »
  }

  function initial() {
    fetchFullBestsellers(); // background: enrich the pool from 24 → up to 96
    var racine = racineTiroir();
    if (racine) {
      new MutationObserver(auTiroirOuvert)
        .observe(racine, { attributes: true, attributeFilter: ['class'] });
    }
    auTiroirOuvert();   // le tiroir est déjà ouvert au chargement : cas rare, pas impossible
    renderStrip();      // self-guards on is-open
  }

  /* cart:refresh already fires on every cart mutation across cart-drawer.js,
     cart-drawer-discount.js and onix-discount-bar.liquid — no count-badge
     observer needed (it just doubled the scheduling). */
  document.addEventListener('cart:refresh', schedule);
  window.addEventListener('pageshow', function (e) { if (e.persisted) schedule(); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initial, { once: true });
  } else {
    initial();
  }
})();
